import React from 'react';
import injectSheet from 'react-jss';
import { InsertInDom } from '../InsertInDom';

/**
 * 
 * It is a generic modal with a default backdrop.
 * The content of the modal is dynamic.
 * It basically creates a portal inside  dom at the top most level of body element
 *  
 */


 function Modal({children,classes, className, opacity, onClose, ...rest}){
    return(
        <InsertInDom>
            <div className={`${classes.container} ${className}`} {...rest}>
                <div className={classes.content}>
                 <div onClick={onClose}  style={{opacity}} className={classes.overlay}/>
                 {children}
                </div>
            </div>
        </InsertInDom>

    )
}

Modal.defaultProps = {
    className: '',
    opacity: 0.5
}

const style ={
    container: {
        position: 'fixed',
        top:0,
        left:0,
        right:0,
        bottom:0,
        zIndex: 10000
    },
    overlay: {
        position: 'absolute',
        top:0,
        left:0,
        right:0,
        bottom:0,
        zIndex: -1,
        backgroundColor: 'rgba(0,0,0,0.5)'
    },
    content: {
        position: 'absolute',
        top:0,
        left:0,
        right:0,
        bottom:0,
        zIndex:2,
        display:'flex',
        justifyContent:'center',
        alignItems:'center'
    }
}

export const GenericModal = injectSheet(style)(Modal);